// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

/**
 * @typedef {import('../types/plottr').FamilyTree} FamilyTree
 */

import { createSelector } from 'reselect'

import { fullFileStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 */

/**
 * @type {function(PlottrState): Record<String, FamilyTree>}
 */
export const allFamilyTreesSelector = createSelector(
  fullFileStateSelector,
  ({ familyTrees }) => familyTrees ?? {}
)

/**
 * @type {function(PlottrState, number): number}
 */
const familyTreeIdSelector = (_state, id) => {
  return id
}

/**
 * @type {function(PlottrState, number): FamilyTree | Null}
 */
export const familyTreeSelector = createSelector(
  allFamilyTreesSelector,
  familyTreeIdSelector,
  (familyTrees, id) => {
    return familyTrees[id] ?? null
  }
)
